import React, { useState } from "react";
import { Box, Drawer, IconButton, Modal, Tooltip } from "@mui/material";
import PageConverter from "./PageConverter";
import { Steper } from "../components/MUI/Step";
import SideDrawer from "../components/Custome/SideDrawer";

const FloatComp = ({
  jsonData,
  event,
  customProps = {},
  open = true,
  onClose,
}) => {
  const [activeStep, setActiveStep] = useState(0);

  const handleDrawerClose = () => {
    if (onClose) onClose();
  };

  switch (event) {
    case "Open Sidebar":
      return (
        <Drawer anchor="right" open={open} onClose={handleDrawerClose}>
          <SideDrawer
            handleDrawerClose={handleDrawerClose}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            steps={jsonData?.steps}
            isStepper={jsonData?.isStepper}
            jsonData={jsonData}
          >
            {jsonData?.isStepper ? (
              <>
                <Steper
                  steps={jsonData?.steps}
                  activeStep={activeStep}
                  style={{ margin: "32px 0" }}
                />
                {jsonData?.pages?.map((el, i) => {
                  return (
                    activeStep === i && (
                      <Box width="fit-content" margin="0 auto" key={i}>
                        <PageConverter jsonData={el} />
                        <Box
                          display="flex"
                          m="0 auto 100px"
                          justifyContent={
                            activeStep === 0 ? "flex-end" : "space-between"
                          }
                          alignItems="center"
                          width="100%"
                          minWidth="600px"
                        ></Box>
                      </Box>
                    )
                  );
                })}
              </>
            ) : (
              <PageConverter jsonData={jsonData} customProps={customProps} />
            )}
          </SideDrawer>
        </Drawer>
      );
    case "Open Modal":
      return (
        <Modal open={open} onClose={onClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",

              borderRadius: 2,
              boxShadow: 24,
              minWidth: 320,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <SideDrawer
              handleDrawerClose={handleDrawerClose}
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              steps={jsonData?.steps}
              isStepper={jsonData?.isStepper}
              jsonData={jsonData}
            >
              {jsonData?.isStepper ? (
                <>
                  <Steper
                    steps={jsonData?.steps}
                    activeStep={activeStep}
                    style={{ margin: "32px 0" }}
                  />
                  {jsonData?.pages?.map((el, i) => {
                    return (
                      activeStep === i && (
                        <Box width="fit-content" margin="0 auto" key={i}>
                          <PageConverter jsonData={el} />
                          <Box
                            display="flex"
                            m="0 auto 100px"
                            justifyContent={
                              activeStep === 0 ? "flex-end" : "space-between"
                            }
                            alignItems="center"
                            width="100%"
                            minWidth="600px"
                          ></Box>
                        </Box>
                      )
                    );
                  })}
                </>
              ) : (
                <PageConverter jsonData={jsonData} customProps={customProps} />
              )}
            </SideDrawer>
          </Box>
        </Modal>
      );
    case "Open Tooltip":
      return (
        <Tooltip
          title={
            <PageConverter jsonData={jsonData} customProps={customProps} />
          }
          open={open}
          onClose={onClose}
        >
          <span>{customProps?.tooltipAnchor || "?"}</span>
        </Tooltip>
      );
    case "Close Sidebar":
    case "Close Modal":
    case "Close Tooltip":
      return null;
    default:
      return null;
  }
};

export default function FloatingItem({
  jsonData,
  event,
  customProps = {},
  open = true,
  onClose,
}) {
  return (
    <FloatComp
      jsonData={jsonData}
      event={event}
      customProps={customProps}
      open={open}
      onClose={onClose}
    />
  );
}
